import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { WhatsappLogo, Copy } from "@phosphor-icons/react";

export const WhatsAppButtonInstall = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/integrations/whatsapp-button").then((r) => setInfo(r.data)).catch(() => setInfo({})); }, []);
  if (!info) return null;
  const copy = () => { navigator.clipboard?.writeText(info.snippet || ""); toast.success("Script copiado"); };

  return (
    <div className="mx-5 mb-4 border border-emerald-500/30 bg-emerald-500/5 rounded-md p-4 space-y-3" data-testid="wa-button-install">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-[#25D366] flex items-center justify-center shrink-0"><WhatsappLogo size={22} weight="fill" className="text-white" /></div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold">Botón de WhatsApp para tus sitios web</div>
          <div className="text-xs text-muted-foreground">Ícono flotante en la esquina inferior derecha. Al tocarlo abre WhatsApp con el número de SDM y el bot saluda cuando el cliente escribe.</div>
        </div>
      </div>
      {info.phone ? (
        <div className="text-xs">Número usado: <b className="font-mono" data-testid="wa-button-phone">+{info.phone}</b> <span className="text-muted-foreground">(tomado de esta integración)</span></div>
      ) : (
        <div className="text-xs text-amber-700" data-testid="wa-button-phone-missing">No se pudo obtener el número: guarda un token y Phone Number ID válidos arriba.</div>
      )}
      <div>
        <div className="text-[11px] font-semibold mb-1">Script de instalación</div>
        <div className="flex gap-2">
          <code className="flex-1 font-mono text-[11px] bg-background/70 border border-border rounded px-2 py-2 break-all" data-testid="wa-button-snippet">{info.snippet}</code>
          <Button size="sm" variant="outline" className="gap-1 shrink-0" onClick={copy} data-testid="wa-button-copy"><Copy size={12} /> Copiar</Button>
        </div>
      </div>
      <ol className="text-[11px] text-muted-foreground list-decimal pl-4 space-y-0.5">
        <li>Pega el script justo antes de <code>&lt;/body&gt;</code> en cada sitio (en WordPress: plugin "WPCode" o "Insert Headers and Footers" → Footer).</li>
        <li>Si cambias el número en esta integración, el botón se actualiza solo (puede tardar hasta 5 minutos).</li>
      </ol>
      {info.wa_link && (
        <a href={info.wa_link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700 hover:underline" data-testid="wa-button-test-link">
          <WhatsappLogo size={14} weight="fill" /> Probar el enlace
        </a>
      )}
    </div>
  );
};

export default WhatsAppButtonInstall;
